import React from "react";
import ReactDOM from "react-dom";
import App from "./App";

// Workaround: collapse `//+` in the URL path before React Router 5 consumes
// it (the Identity launcher may emit `//auth/sso`, which doesn't match any
// route). Preserves query and fragment so the SSO token in `#...` survives.
// NOTE: this runs for EVERY path, not just /auth/sso — it's a global, idempotent
// path normalization (`/a//b` → `/a/b`). Harmless for normal routes since they
// never contain repeated slashes, but be aware it's not scoped to the SSO flow.
const collapsedPath = window.location.pathname.replace(/\/{2,}/g, "/");

if (collapsedPath !== window.location.pathname) {
  window.history.replaceState(
    null,
    "",
    `${collapsedPath}${window.location.search}${window.location.hash}`
  );
}

if ("serviceWorker" in navigator) {
  navigator.serviceWorker.register("/worker.js").then(() => {
    console.log("Service Worker Registered");
  });
}

ReactDOM.render(
  // <React.StrictMode>
  <App />,
  // </React.StrictMode>,
  document.getElementById("root")
);
